<div class="modal" id="license-selector-dialog" role="dialog" xmlns="http://www.w3.org/1999/html">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h3>Annual Renewal Agreement for the RIFM Database</h3>
                <div class="nav navbar-left navbar-form">
                    <button class="btn btn-primary navbar-btn" type="button" (click)="onAccept(true)">Accept</button>
                    <button class="btn btn-primary navbar-btn" type="button" (click)="onCancel(false)">Cancel</button>
                </div>
            </div>
            <div class="modal-body">
                <h4 class="user-acknowledgement-title">
                    PLEASE SCROLL DOWN AND READ THE SUBSCRIPTION AGREEMENT. ACCESS TO THE RIFM DATABASE WILL BE GRANTED ONLY UPON AGREEMENT BY THE SUBSCRIBER TO THE TERMS AND CONDITIONS OF
                    THE ONLINE DATABASE SUBSCRIPTION AGREEMENT BELOW.
                </h4>
                <h4 class="user-acknowledgement-centered user-acknowledgement-title-blue">ONLINE DATABASE SUBSCRIPTION AGREEMENT</h4>
                <br/>
                <div [innerHTML]="_userAcknowledgementHTML"></div>
            </div>
            <div class="modal-footer">
                <div class="nav navbar-left navbar-form">
                    <button class="btn btn-primary navbar-btn" type="button" (click)="onAccept(true)">Accept</button>
                </div>
            </div>
        </div>
    </div>
</div>
